import { useEffect } from "react";
import { onAppRendered } from "../lib/native";

/**
 * Rendered inside ErrorBoundary: its first commit means the web bundle booted,
 * so the iOS app can hide the splash and confirm the OTA bundle is healthy.
 * If the app crashes into the error fallback first, it never mounts and the
 * updater rolls back.
 */
export function NativeAppReady() {
  useEffect(() => {
    onAppRendered();
  }, []);
  return null;
}
